const Button = ({
  title,
  onClick,
  type = "button",
  className = "",
  text,
  iconStart = null,
  iconEnd = null,
  hideTextOnMobile = false,
}) => {
  const baseClasses = `flex items-center justify-center gap-2 text-base font-medium rounded-md ${className}`;

  // Set compact padding only if hideTextOnMobile is true
  const paddingClasses = hideTextOnMobile ? "px-2 py-2" : "px-4 py-[10px]";

  return (
    <button
      title={title}
      type={type}
      onClick={onClick}
      className={`${baseClasses} ${paddingClasses} ${className}`}
    >
      {iconStart && <span className="">{iconStart}</span>}
      {text && (
        <span className={hideTextOnMobile ? "hidden md:inline" : ""}>
          {text}
        </span>
      )}
      {iconEnd && <span className="">{iconEnd}</span>}
    </button>
  );
};
export default Button;
